export function apiRoute () {
  if (location.host.includes('localhost')) {
    return 'http://localhost:3000'
  } else {
    return ''
  }
}
